'use client';

import H3 from '@/components/typography/h3';
import Label from '@/components/typography/label';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

export function NotFoundContent() {
    const { t } = useTranslation();

    return (
        <>
            <div className="border-primary mt-20 flex h-[calc(90svh)] flex-col items-center gap-3 border-b px-4 py-20 lg:justify-center lg:gap-5 lg:px-8">
                <H3 className="text-center lg:text-left">{t('title')}</H3>
                <Link href="/" className="underline">
                    <Label
                        className="px-20 text-center underline lg:text-left"
                        variant="button"
                    >
                        {t('description')}
                    </Label>
                </Link>
            </div>
            <Image
                src="/images/404.png"
                alt={t('image.alt')}
                width={600}
                height={600}
                className="absolute top-[10rem] left-[-8rem] z-40 h-auto w-[500px] lg:w-[500px] 2xl:top-20 2xl:left-[-12rem] 2xl:w-[700px]"
            />
        </>
    );
}

NotFoundContent.displayName = 'NotFoundContent';
export default NotFoundContent;
